const cn = {
    'menu': ['数字货币', '创新与可靠', '稳定的数字资产', '为何使用BVCPay', '如何使用BVCPay'],
    'footmenu': ['首页', '关于', '联系', '其它'],
    'part1_txt1': '代表数字时代的数字货币',
    'part1_txt2': '全球实时的支付解决方案',
    'part1_txt3': '',
    'part1_txt4': '',
    'part1_txt5': '全球，快速，安全',
    'part1_txt6': '下载',

    'part2_txt1': '通过以下网址查询BVCChain中的交易情况：',
    'part2_txt2': '如需商业咨询，请发送邮件至：',
    'part2_txt11': '通过以下网址进入BVCChain的开发者平台：',
    'part2_txt22': '通过Github可获得BVCChain开放的资源：',
    'part2_txt3': '创新可靠',
    'part2_txt4': '具有区块链技术的高效及传统货币的稳定',

    'part3_txt1': '稳定的数字资产',
    'part3_txt2': 'BVC将现金转换为数字货币，将价值锚定或限制为本国货币的价格，如加元。',
    'part3_txt3': '',
    'part3_txt4': '100％支持',
    'part3_txt5': '我们实际的银行账户中的加元与发行的CADT相对应以此确保兑换比例1:1，即为1CADT=C$ 1CAD 。',
    'part3_txt6': '透明',
    'part3_txt7': '每天公布银行资金账目情况，及其CADT的每日交易账本情况。',
    'part3_txt8': '安全与可信',
    'part3_txt9': 'BVC是一家金融服务公司，受加拿大金融服务部监管，具有丰富的法定和数字资产中介经验。 CADT是BVC发行的数字资产，与加元等值。',
    'part3_txt10': '实时',
    'part3_txt11': '在BVC上可24小时数字资产交易结算。您可以将数字资产兑换为等值的法币，并可在3个工作日内完成兑换。',

    'part4_txt1': '为何使用BVCPay',
    'part4_txt2': '与加元等值的数字资产可兑换结算为法币现金',
    'part4_txt3': '更便捷、简便地数字资产交易及转账流通',
    'part4_txt4': '在任何地方任何时间都可交易结算',
    'part4_txt5': '快速及时地跨境交易',
    'part4_txt6': 'BVC 是基于区块链技术的开放式平台，同时确保了平台安全、公开、高效。',

    'part5_txt1': '如何使用BVCPay',
    'part5_txt2': '用户手册 (英文版)',
    'part5_txt3': '用户手册 (中文版) ',
    'part5_txt4': '用户手册 (视频)',
    'part5_txt5': '关于我们 (视频)',

    'dl_txt1': 'BVC PAY',
    'dl_txt2': '基于区块链技术的去中心化资产交易和支付应用',
    'dl_txt3': '安全',
    'dl_txt4': '可靠',
    'dl_txt5': '去中心化',
    'dl_txt6': '安全 可靠',
    'dl_txt7': '基于BVCChain生态体系，原生支持多资产和去中心化的资产交易',
    'dl_txt8': '去中心化',
    'dl_txt9': '所有用户秘钥完全由用户保存，无中心化解决方案的弊端，百分之百保证资产交易数据的真实和资产的安全',
    'dl_txt10': '安全可靠',
    'dl_txt11': '采用 BVC2L 算法，确保安全、可靠、高效',
    'dl_txt12': '可信便捷',
    'dl_txt13': '可以实时查询历史交易记录，交易记录可信和不可篡改',
    'dl_txt14': '功能介绍',
    'dl_txt15': '方便，快捷，高效',
    'dl_txt16': '资产管理',
    'dl_txt17': '可查询多种资产持有概况',
    'dl_txt18': '资产授信、交易密码设置',
    'dl_txt19': '交易密码、密钥等多重安全机制，确保资产安全',
    'dl_txt20': '资产交易',
    'dl_txt21': '资产总额、可用清晰可见',
    'dl_txt22': '可查看历史交易明细，确保账目清晰',
    'dl_txt23': '通过收款地址资产转账，方便快捷',
    'dl_txt24': '联系人管理',
    'dl_txt25': '简单快捷维护联系人地址',
    'dl_txt26': '联系人间转账更快速便捷',
    'dl_txt27': '可快速查询筛选联系人及收款地址',

    'direct_download': '直接下载'
}

export default cn